import { AbstractControl, ValidationErrors, UntypedFormGroup } from "@angular/forms";

// export class ConfirmPasswordValidator {
//     static confirmPassWord(control: AbstractControl): ValidationErrors | null {
//         if (control.get("oldPassword") !== control.get("newPassWord")) {
//             return { inValidconfirmPassWord: true }
//         }
//     }
// }

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}